export type PdfSource = string | URL | Uint8Array | ArrayBuffer;

/**
 * pdf.js opens a blob: URL through XMLHttpRequest with a URL object, which Faro 2.13's XHR hook
 * cannot take (`url.match is not a function`). The blob is in memory anyway, so read it here.
 * https://github.com/grafana/faro-web-sdk/issues/2343
 */
export const readPdfSource = async (src: PdfSource): Promise<PdfSource> => {
  if ((typeof src === 'string' || src instanceof URL) && String(src).startsWith('blob:')) {
    const response = await fetch(src);
    return new Uint8Array(await response.arrayBuffer());
  }
  return src;
};
